import { render, staticRenderFns } from "./CustomerBoxEdit.vue?vue&type=template&id=20f49ecc&scoped=true"
import script from "./CustomerBoxEdit.vue?vue&type=script&lang=js"
export * from "./CustomerBoxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f49ecc",
  null
  
)

export default component.exports